"use client";

import { useEffect } from "react";
import { useRegionDropdownDataContext } from "@/providers/RegionDropdownDataContextProvider";

interface PageDataSyncProps {
	localeUrls: string[] | null;
}

/**
 * Client component that syncs localization string array from server to client context.
 * This allows server components to pass data that needs to be available in client context.
 * Place this component in the layout after RegionDropdownDataContextProvider.
 */
export default function PageDataSync({ localeUrls }: PageDataSyncProps) {
	const { setLocaleUrlsHandler } = useRegionDropdownDataContext();

	useEffect(() => {
		if (localeUrls && Array.isArray(localeUrls)) {
			// Filter to ensure only strings are passed to the handler
			const stringUrls = localeUrls.filter(
				(url): url is string => typeof url === "string",
			);
			if (stringUrls.length > 0) {
				setLocaleUrlsHandler(stringUrls);
			}
		}
	}, [localeUrls, setLocaleUrlsHandler]);

	return null;
}
